
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class UnderlineForm extends Vue {
    @Prop({required: true})
    beforetext!: string;

    @Prop({required: false, default:''})
    aftertext!: string;

    @Prop({required: true})
    text!: string;

    @Prop({required: true})
    hint!: string;

    @Prop({required: true})
    textwidth!: string;

    @Prop({required: false, default:'6pt'})
    hintFontSize!: string;
    
    @Prop({required:false, default:false})
    italicHint!: boolean;

    @Prop({default: '-20px'})
    marginTop!: string;
}
